export function formatUploadDenominator({ planType, includedUnits }) {
  if (planType === 'with_included_units') {
    return { key: 'included_units_denominator', params: [includedUnits] };
  }
  if (planType === 'unlimited') {
    return { key: 'unlimited_denominator' };
  }
  return { key: 'none_denominator' };
}
